import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import type { TariffAccessBannerContent, TariffAccessBlockReason } from "../../utils/tariffAccess";
import "./TariffAccessBanner.scss";

interface TariffAccessBannerProps {
  banner: TariffAccessBannerContent;
  blockReason?: TariffAccessBlockReason | null;
  className?: string;
}

export const TariffAccessBanner = ({ banner, blockReason, className }: TariffAccessBannerProps) => {
  const infoReasons = new Set([
    "no_tariff",
    "upcoming_tariff",
    "pending_payment",
    "tariff_requested",
    "period_expired",
    "type_disabled",
  ]);
  const variantClass = infoReasons.has(blockReason ?? "")
    ? " tariff-access-banner--info"
    : " tariff-access-banner--warning";

  return (
    <div
      className={`tariff-access-banner${variantClass}${className ? ` ${className}` : ""}`}
      role="alert"
    >
      <span className="tariff-access-banner__icon" aria-hidden>
        <AlertTriangle size={22} strokeWidth={2} />
      </span>
      <div className="tariff-access-banner__content">
        <p className="tariff-access-banner__title">{banner.title}</p>
        <p className="tariff-access-banner__text">{banner.description}</p>
      </div>
      <Link to="/tariffs" className="btn btn-primary tariff-access-banner__link">
        Перейти к тарифам
      </Link>
    </div>
  );
};
